module.exports = __webpack_public_path__ + "img/hgnn-min.9fad4aba.jpg";